<template>
  <div>
    <div class="top-b">
      <!-- <img class="banner" src="../../assets/index_image.jpg" alt=""> -->
      <div class="title">
        <div class="title-a">专业的智能融合CDN提供商</div>
        <div class="title-b">全网优质资源调度   无惧突发及故障   打造极致服务体验</div>
      </div>
      
      <div class="top-nav text-center">
        <router-link to="/loginCdn">管理后台</router-link>
      </div>
    </div>
    <div class="container">
      <div class="row in_con">
        <div class="col-xs-12 col-sm-6 sec">
          <img src="../../assets/Advantage_icon01.png">
          融合CDN
          <p>
            悦享互联通过对接多家CDN厂商，形成一个超过50T的巨大CDN资源池，再基于监控体系及大数据分析平台，对平台内的CDN节点服务质量进行择优选择，并与智能调度系统联动，将互联网用户访问调度到最适合的CDN厂商节点上，为CDN客户提供优质、稳定、易用的CDN服务。
          </p>
        </div>
        <div class="col-xs-12 col-sm-6 pic">
          <img src="../../assets/ronghe_right.jpg">
        </div>
      </div>
      <div class="row in_con">
        <div class="col-xs-12 col-sm-6 sec">
          <img src="../../assets/Advantage_icon01.png">
          监控体系
          <p>
            悦享互联独有100+监控节点，对各种监控手段采集回来的数据进行实时合并，去噪，关联分析， 第一时间发现问题，形成可供调度系统或者运营人员决策的结论。
          </p>
        </div>
        <div class="col-xs-12 col-sm-6 pic">
          <img src="../../assets/monitor_right.jpg">
        </div>
      </div>
      <div class="row in_con">
        <div class="col-xs-12 col-sm-6 sec">
          <img src="../../assets/Advantage_icon01.png">
          智能调度
          <p>
            智能调度系统与监控分析系统联动，根据故障级别进行相应的智能调度决策，对于可用性故障，节点故障，异常状态码等按设置的阈值自动切换；对于网络抖动、下载速度、响应时间等异常情形进行人工优化。
          </p>
        </div>
        <div class="col-xs-12 col-sm-6 pic">
          <img src="../../assets/boss_right.jpg">
        </div>
      </div>
      <div class="row in_con">
        <div class="col-xs-12 col-sm-6 sec">
          <img src="../../assets/Advantage_icon01.png">
          聚合BOSS系统
          <p>
            掌控整个融合CDN平台的运营状态，实现从基础数据到运维、运营的全方面管控，不管是资源、服务、状态、任务体系、API体系，还是监控、调度、计费及问题跟进，做到全局可控。
          </p>
        </div>
        <div class="col-xs-12 col-sm-6 pic">
          <img src="../../assets/boss_struct.jpg">
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script type="text/javascript">
import Footer from '../../components/Footer'
export default {
  components: {
    Footer
  }
}
</script>

<style scoped>
.top-b {
  height: 500px;
  background: url("../../assets/index_image.jpg") no-repeat center center;
  background-size: cover;
  position: relative;
}
.title {
  width: 100%;
  position: absolute;
  top: 30%;
  text-align: center;
  color: #fff;
}
.title-a {
  font-size: 70px;
}
.title-b {
  font-size: 25px;
  letter-spacing: 5px;
}
.top-nav {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 20px;
  /* background: #fff;
  box-shadow: 1px 2px 20px rgba(0, 0, 0, .3);*/
  padding: 0px;
}

.top-nav a {
  padding: 20px 20px;
  display: block;
  font-size: 20px;
  color: #fff;
}

.in_con {
   margin: 50px auto;
}
.in_con p {
  font-size: 1.8rem;
  color: #333;
  text-indent: 30px;
  margin-bottom: 40px;
  line-height: 33px;
}
.sec img {
  width: 40px;
  vertical-align: middle;
  margin: 5px;
}
</style>
